import React from 'react'
import { Grid, Typography } from '@mui/material'
import moment from 'moment'
import { Services } from '../../../services'

const ResumoAgendamento = ({ horario, tituloDiaria, data, diaDiaria, nomeEmpresa, nomeQuadra, endereco }) => {
  return (
    <>
      <Grid item xs={12} sx={{ backgroundColor: '#f5f5f5', padding: '8px', borderRadius: '7px 7px 0px 0px', width: '100%' }}>
        <Grid container>
          <Grid item xs={3}>
            <Typography variant='h6' className='text-label-low label-left'>
              {!tituloDiaria ? 'Horário' : 'Diária'}
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <Typography variant='h6' className='text-label-low label-right label-bold'>
              {tituloDiaria || Services.RetornaPeriodoSelect(horario)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{ backgroundColor: '#f5f5f5', padding: '8px', marginBottom: '2px', width: '100%' }}>
        <Grid container>
          <Grid item xs={3}>
            <Typography variant='h6' className='text-label-low label-left'>
              Data
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <Typography variant='h6' className='text-label-low label-right label-bold'>
              {moment(diaDiaria || data).format('dddd, DD [de] MMMM [de] YYYY')}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{ backgroundColor: '#f5f5f5', padding: '8px', borderRadius: '0px 0px 7px 7px', width: '100%' }}>
        <Grid container>
          <Grid item xs={3} container alignItems='center' padding='0px'>
            <Typography variant='h6' className='text-label-low label-left'>
              Local
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <Typography variant='h6' className='text-label-low label-right label-bold'>
              {nomeEmpresa || 'Arena Esporte'}
            </Typography>
            <Typography variant='h6' className='text-label-low label-right label-bold'>
              {nomeQuadra}
            </Typography>
            <Typography variant='h6' className='text-label-low label-right label-bold' sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
              {endereco}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default ResumoAgendamento
